import * as jsonpath from '../../../../../../External/jsonpath';

interface IPathComponent {
    expression: {
        // eslint-disable-next-line
        type: string;
        value: string | number;
    };
    scope?: string;
    operation?: string;
}

export function buildJsonPath(pathItems: jsonpath.PathComponent[], alwaysEscape?: boolean): string {
    let pathString = '$';
    const templates: { [key: string]: string } = {
        'descendant-member': '..{{value}}',
        'child-member': '.{{value}}',
        'descendant-subscript': '..[{{value}}]',
        'child-subscript': '[{{value}}]'
    };
    const path = normalize(pathItems, alwaysEscape);

    path.forEach((component: IPathComponent) => {

        if (component.expression.type === 'root') {
            return;
        }

        const key = [component.scope, component.operation].join('-');
        const template = templates[key];
        const value = component.expression.type === 'string_literal' ? escapeStringWithSingleQuote(component.expression.value as string) : (component.expression.value + '');

        if (!template) {
            throw new Error('couldn\'t find template ' + key);
        }

        pathString += template.replace(/{{value}}/, value);
    });

    return pathString;
}

function escapeStringWithSingleQuote(str: string): string {
    return '\'' + str.replace(/'/g, '\\\'') + '\'';
}

function normalize(path: jsonpath.PathComponent[], alwaysEscape?: boolean): IPathComponent[] {

    if (Array.isArray(path) && typeof path[0] === 'string') {

        const _path: IPathComponent[] = [{ expression: { type: 'root', value: '$' } }];

        path.forEach((component, index) => {

            if (component === '$' && index === 0) {
                return;
            }

            if (!alwaysEscape && typeof component === 'string' && component.match('^[a-zA-Z_]+[a-zA-Z0-9_]*$')) {

                _path.push({
                    operation: 'member',
                    scope: 'child',
                    expression: { value: component, type: 'identifier' }
                });

            } else {

                const valType = typeof component === 'number' ? 'numeric_literal' : 'string_literal';

                _path.push({
                    operation: 'subscript',
                    scope: 'child',
                    expression: { value: component, type: valType }
                });
            }
        });
        return _path;
    }

    throw new Error('couldn\'t understand path ' + path);
}
